import { render } from "./AllTickets.vue?vue&type=template&id=45ffbb7e&ts=true"
import script from "./AllTickets.vue?vue&type=script&lang=ts"
export * from "./AllTickets.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__